
export default class lsUtil {

    static AWS_COGNITO_ACCESS_KEY = 'AWS_COGNITO_ACCESS_KEY';
    static AWS_COGNITO_SESSION_KEY = 'AWS_COGNITO_SESSION_KEY';
    static AWS_COGNITO_SECRET_ACCESS_KEY = 'AWS_COGNITO_SECRET_ACCESS_KEY';
    static AWS_COGNITO_USER_POOL_ID_TOKEN_JWT = 'AWS_COGNITO_USER_POOL_ID_TOKEN_JWT';
    static RC_API_JWT = 'RC_API_JWT';
    static RC_API_JWT_EXPIRATION = 'RC_API';
    static AWS_COGNITO_USER_ACCOUNT = 'AWS_COGNITO_USER_ACCOUNT';
    static AWS_COGNITO_USER_PENDING_INVITE = 'AWS_COGNITO_USER_PENDING_INVITE';
    static USER_SURVEYS = 'raven.surveys.{user_email}';

    static RAVENS = "RAVENS";

    static S3 = {
        BUCKET_NAME: 'BUCKET_NAME',
        USER_DATA_PATH_KEY: 'USER_DATA_PATH_KEY'
    }

    static getLocalStorage() {
        let storage = window.localStorage || localStorage;
        if (!localStorage) {
            return false;
        }
        return storage;
    }

    static setItem(key, value) {
        if (this.getLocalStorage())
            lsUtil.getLocalStorage().setItem(key, value);
    }

    static getItem(key) {
        if (this.getLocalStorage())
            return lsUtil.getLocalStorage().getItem(key);
    }

    static setObject(key, value) {
        if (this.getLocalStorage())
            lsUtil.setItem(key, JSON.stringify(value));
    }

    static getObject(key) {
        if (this.getLocalStorage())
            return JSON.parse(lsUtil.getItem(key) || '{}');
    }

    static removeItem(key) {
        if (this.getLocalStorage())
            lsUtil.getLocalStorage().removeItem(key);
    }

    static clear() {
        if (this.getLocalStorage())
            lsUtil.getLocalStorage().clear();
    }

    static key(index) {
        if (this.getLocalStorage())
            return lsUtil.getLocalStorage().key(index);
    }
}